import { gql } from 'graphql-request';

export default gql`
  query menuById($mask: String, $id: String) {
    menuById(mask: $mask, id: $id) {
      id
      account_id
      doc
      listing
    }
  }
`;
